interface Props {
  title: string
}

function PrintHeader({ title }: Props) {
  return (
    <>
      <h1>{title}</h1>
      <hr />
    </>
  )
}

export default PrintHeader